"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentConnectionFromPortal = void 0;
const getCurrentConnectionInfo_1 = require("./getCurrentConnectionInfo");
const getPortalSdk_1 = require("./getPortalSdk");
const getCurrentConnectionFromPortal = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    const sdk = (0, getPortalSdk_1.getPortalSdk)();
    if (!sdk) {
        return null;
    }
    const urlInfo = (0, getCurrentConnectionInfo_1.getCurrentConnectionInfo)(window);
    if (!urlInfo) {
        return null;
    }
    const connection = yield sdk.getConnectionByIndex(urlInfo.connectionIndex);
    if (!connection) {
        return null;
    }
    const { endpoint } = connection;
    return {
        isPortalConnection: true,
        endpoint,
        name: '',
        password: '',
        token: (_a = connection.token) !== null && _a !== void 0 ? _a : undefined,
        useBrowserAuth: (_b = connection.useBrowserAuth) !== null && _b !== void 0 ? _b : undefined,
        username: (_c = connection.username) !== null && _c !== void 0 ? _c : '',
    };
});
exports.getCurrentConnectionFromPortal = getCurrentConnectionFromPortal;
